// @ts-nocheck
// Recordings ACL — a call recording (column / tab / field / player) is shown
// only when the logged-in user has `read` on the Recordings module.
// Superadmin always can. Voicemails are not gated by this.
import { getUser } from "./setting";
import { MODULE_ACL, USER_ROLES } from "./constant";
import { parseModuleOperations } from "./voicePlanAcl";
import { parseCdrMediaReference } from "./cdrMedia";

export function canReadRecordings() {
  const user = getUser();
  if (user?.role === USER_ROLES.SUPERADMIN) return true;
  const ops = parseModuleOperations(user?.acl_settings?.module_operations);
  return !!ops?.[MODULE_ACL.RECORDINGS]?.read;
}

export function isAgentVoicemailEnabled(user = getUser()) {
  return Boolean(user?.agentData?.is_voicemail_enabled ?? user?.agent_details?.is_voicemail_enabled);
}

export const isVoicemailEntry = (entry) =>
  String(entry?.type || entry?.kind || "").toLowerCase() === "voicemail";

/**
 * Reference-mode `recording_file`: is there anything this user may see?
 * Without Recordings `read` nothing is shown (no View Details), voicemails included.
 */
export function hasVisibleCdrMedia(recordingFile) {
  if (!canReadRecordings()) return false;
  const ref = parseCdrMediaReference(recordingFile);
  if (!ref) return false;
  return ref.voicemailIds.length > 0 || ref.recordingIds.length > 0;
}
